import { InjectionToken } from '@angular/core';
import { Route } from '@angular/router';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ROUTES_CONFIG = new InjectionToken<Record<string, Route>>('routes.config');
